/* eslint-disable import/no-cycle */
import React from 'react';

import TestWhyModal from '../TestWhyModal';
import { GMAData } from '../../../constants/testData';

export default props => (
  <TestWhyModal studies={GMAData.studies} {...props} />
);
